<template>
  <van-popup v-model="openModal" position="bottom" @click-overlay="clickMask">
    <Header class="van-hairline--bottom" show-right rightIcon="icon-close" title="选择体检中心"
            @clickRight="clickMask"></Header>
    <div class="tree-wrap row">
      <div class="col-4" ref="cityList">
        <Item class="clear-bg text-center" :id="item.id"
              :class="{active:(selectCityId?item.id===selectCityId : item.id===cityId)}"
              v-for="item in cityList"
              :key="item.id"
              :title="item.name" @click="navClick($event,item)"></Item>
      </div>
      <div class="col-8">
        <!--<Item vTag="a" :to="hasRouter?item.id:''" class="clear-bg text-center van-hairline&#45;&#45;bottom"-->
        <!--:class="{active:(selectSysCenterId?item.id===selectSysCenterId : item.id===sysCenterId)}"-->
        <!--v-for="(item) in sysCenterList" :title="item.name"-->
        <!--:key="item.id"-->
        <!--@click="itemClick($event,item)"></Item>-->
        <div class="sysCenterMsg" v-for="(item) in sysCenterList" @click="itemClick($event,item)"
             :class="{active:(selectSysCenterId?item.id===selectSysCenterId : item.id===sysCenterId)}">
            <div class="img"><img :src="getImageData(item.image)" alt=""></div>
           <p>{{ item.name }}</p>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import Item from '../item'
import Header from '../header'
import getCurrentPosition from '@/assets/scripts/geolocaion'
import { Loading } from '@/assets/scripts/helper'
import { Popup } from 'vant'
import Vue from 'vue'

Vue.use(Popup)
export default {
  components: {
    Item,
    Header
  },
  data () {
    return {
      selectCityId: '',
      selectSysCenterId: '',
      flag: false
    }
  },
  props: {
    hasRouter: {
      type: Boolean
    },
    showModal: {
      type: Boolean
    },
    positionCityId: {
      type: String,
      default: ''
    },
    /**
       * 按业务类型过滤体检中心列表数据
       * existCard 支持健康管理服务卡
       * individuationOpt 支持个体化问诊
       * projectSelectOpt 支持纯自选体检项目  (包括支持在套餐基础上添加自选项目)
       * receiveOnline 支持在线领取体检报告
       */
    mode: {
      type: String
    }
  },
  computed: {
    openModal: {
      get: function () {
        if (this.$store.state.sid !== '00-0') {
          return false
        } else {
          return this.showModal
        }
      },
      set: function (v) {
        return !this.showModal
      }
    },
    cityId () {
      let id = (this.$store.state.center.position.id || (this.$store.state.center && this.$store.state.center.sysCenter.cityId) || '')
      if (id && this.openModal) {
        let $this = this
        this.$nextTick(() => {
          $this.$refs['cityList'].scrollTop = document.getElementById(id).offsetTop - 100
        })
      }
      return id
    },
    cityList () {
      let $this = this
      let flag
      let cityList = []
      if ($this.mode) {
        for (let city of ((this.$store.state.center && this.$store.state.center.cityList) || [])) {
          flag = false
          for (let sysCenter of city.children) {
            if (sysCenter[$this.mode] === 1) {
              flag = true
              break
            }
          }
          if (flag) {
            cityList.push(city)
          }
        }
      } else {
        cityList = (this.$store.state.center && this.$store.state.center.cityList) || []
      }
      return cityList
    },
    sysCenterId () {
      return (this.$store.state.center && this.$store.state.center.sysCenter.id) || ''
    },
    sysCenterList () {
      let $this = this
      try {
        return this.cityList.find(item => $this.selectCityId ? item.id === $this.selectCityId : item.id === $this.cityId).children
      } catch (err) {
        return []
      }
    }
  },
  methods: {
    getImageData (url) {
      url = this.$store.state.imageResourcesUrl + (url ? url.split(',')[0] : `/wx/img/img-center.png`)
      return url
    },
    currentPosition () {
      let $this = this
      getCurrentPosition().then(function (position) {})
    },
    clickMask (e) {
      this.$emit('maskClick', e)
    },
    navClick (e, data) {
      e.stopPropagation()
      this.selectCityId = data.id
      this.$emit('navClick', data)
    },
    async itemClick (e, data) {
      e.stopPropagation()
      Loading.show()
      this.selectSysCenterId = data.id
      await this.$store.dispatch('center/loadSysCenterDetail', data.id)
      this.$emit('itemClick', data)
      this.clickMask(e)
      Loading.close()
    }
  },
  watch: {
    openModal: function (val, oldVal) {
      if (val && ((this.sysCenterList && this.sysCenterList.length === 0) || !this.sysCenterList)) {
        Loading.show()
        this.$store.dispatch('center/loadSysCenterList').then(() => Loading.close())
      } else {
        Loading.close()
      }
    },
    positionCityId: {
      handler (newValue, oldValue) {
        this.selectCityId = newValue
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/style/variables.scss';

  .head-title {
    height: 48px;
    line-height: 48px;
    text-align: center;
    font-size: 16px;
  }

  .tree-wrap {
    height: 495px;
    > div {
      overflow-x: hidden;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      .active /deep/ {
        background: $light !important;
        h3 {
          color: $assertive;
        }
      }
    }
    .col-4 {
      background: $grey;
    }
  }
  .sysCenterMsg {
    border-radius: 5px;
    overflow: hidden;
    margin: 15px auto;
    width: 200px;
    text-align: center;
    border: 1px solid #ddd;
    p{
      padding: 8px 5px;
    }
    .img{
      font-size: 0;
      line-height: 0;
    }

    img {
      width: 100%;
      height: 90px;
      object-fit: cover;
    }
  }

</style>
